module.exports = __webpack_public_path__ + "img/E3.0b7358aa.jpg";